/**
 * Split Banner Component JavaScript
 * Handles Split Banner functionality - reuses product detail logic for modal features
 * Simple wrapper for now, additional logic can be added later
 */

var detail = require('../product/details');

var splitBanner = detail;

// Export initialization function for SFRA processInclude pattern
module.exports = function () {
    return splitBanner;
}; 